class UrlQualifier {
	static possibleSchemes = [
		'skype',
		'ldap',
		'tel',
		'telnet',
		'urn',
		'ms-appx',
		'ms-appx-web',
		'ms-appdata',
		'ms-resource',
		'vsmacros',
		'net.pipe',
		'net.tcp',
		'uuid',
		'wss',
		'ws',
		'sip',
		'file',
		'ftp',
		'gopher',
		'http',
		'https',
		'mailto',
		'net.pipe',
		'net.tcp',
		'news',
		'nntp',
	];
	static reDocRegexUrl =
		/((?:[a-z][\w-]+:(?:\/{0,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s<>"]*))/i;
	static reDocRegexUrlGlobal =
		/((?:[a-z][\w-]+:(?:\/{0,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s<>"]*))/gi;

	static getPathInfo = (path: string) => {
		//  create a link in the DOM and set its href
		const link = document.createElement('a');
		link.setAttribute('href', path);
		//  return an easy-to-use object that breaks apart the path
		return {
			host: link.hostname, //  'example.com'
			port: link.port, //  12345
			path: link.pathname, //  '/blog/foo/bar'
			protocol: link.protocol, //  'http:'
		};
	};

	static getReformated = (text: string): string => {
		return text
			.replace(/\n/g, '<br>')
			.replace(this.reDocRegexUrlGlobal, (str) => {
				const pathinfo = this.getPathInfo(str);
				const protocol = pathinfo.protocol.slice(0, -1);
				if (this.possibleSchemes.indexOf(protocol) !== -1) {
					if (!str.startsWith(protocol)) {
						return (
							'<a href=' +
							protocol +
							'://' +
							str +
							' target="_blank">' +
							str +
							'</a>'
						);
					} else {
						return (
							'<a href=' +
							str +
							' target="_blank">' +
							str +
							'</a>'
						);
					}
				}
				return str;
			});
	};
}

export default UrlQualifier;
